import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Box, Typography } from "@mui/material";

export default function CreateMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="create-button"
        startIcon={<AddIcon />}
        aria-controls={open ? "create-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        fullWidth
      >
        Create
      </Button>
      <Menu
        id="create-menu"
        aria-labelledby="create-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenu-list": {
            minWidth: "240px",
            paddingBottom: "15px",
          },
        }}
      >
        <MenuItem
          onClick={handleClose}
          component={RouterLink}
          to={`/create`}
          state={{
            customer: "",
            items: [],
            chargeType: "invoice",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
            }}
          >
            <Typography variant="body1" fontWeight="medium" sx={{ wordBreak: "break-word" }}>
              Invoice
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              Send an itemized invoice that customers can pay online.
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleClose} component={RouterLink} to={`/create`}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
            }}
          >
            <Typography variant="body1" fontWeight="medium" sx={{ wordBreak: "break-word" }}>
              Order
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              Accept payment in-store or over phone & create an itemized order.
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleClose} component={RouterLink} to={`/quick-charge`}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
            }}
          >
            <Typography variant="body1" fontWeight="medium" sx={{ wordBreak: "break-word" }}>
              Quick Charge
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              Simply enter an amount & accept a payment.
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </div>
  );
}
